/**
 * The one place a billing write goes stale from (contract item 3).
 *
 * ['invoices', 'unbilled', slug] is a SIBLING of ['invoices', 'list',
 * slug] on purpose: the list key goes on to carry the client, pile and
 * offset segments, and the unbilled report must ignore all three. The
 * cost of the sibling is that TanStack prefix matching never crosses it,
 * so an invalidation aimed at the list alone leaves the unbilled line
 * stale after the exact writes that change it (void frees events back
 * off an invoice; compile takes them on). Every site that invalidated
 * the list now calls this instead: one helper, because four hand-widened
 * call sites drift.
 *
 * It also refreshes the invoice details (['invoices', 'detail', slug]):
 * a draft's preview counts the period's notes that are not Ready. Every
 * note-side write that changes billing facts (Ready, the billing fields,
 * the invoice line, a new version, a removal, a re-read) calls it too,
 * so the invoice pages never show a report from before the write.
 */

import type { QueryClient } from '@tanstack/react-query';

export function invalidateInvoiceReads(queryClient: QueryClient, tenantSlug: string): void {
  void queryClient.invalidateQueries({ queryKey: ['invoices', 'list', tenantSlug] });
  void queryClient.invalidateQueries({ queryKey: ['invoices', 'unbilled', tenantSlug] });
  void queryClient.invalidateQueries({ queryKey: ['invoices', 'detail', tenantSlug] });
}
